<template>
  <div class="document">
    <section>
      <h1>About Us</h1>
      <p>At BookDirect.com, we’re redefining the way travellers book accommodations—connecting you directly with hotels to eliminate unnecessary fees and put the savings back in your pocket.</p>
    </section>

    <section>
      <h2>Our Mission</h2>
      <p>We believe booking a hotel should be simple, transparent, and cost-effective. By cutting out commissions charged by online travel agencies, we empower hotels to offer you:</p>
      <ul>
        <li><strong>Guaranteed lower rates</strong> – No hidden markups, just the best direct prices.</li>
        <li><strong>Better availability & Flexible Booking Options </strong> – Get access to more room choices, including exclusive offers with many hotels offering free cancellations and modifications.</li>
        <li><strong>Exclusive perks</strong> – Enjoy room upgrades, late checkouts, and special amenities.</li>
      </ul>
    </section>

    <section>
      <h2>The BookDirect Advantage</h2>
      <p>Our user-friendly platform gives you <strong>real-time access</strong> to hotels worldwide with dynamic pricing, ensuring you get the best available deal directly from the source. Whether it’s a spontaneous weekend getaway or an extended stay, <strong>BookDirect.com</strong> makes it seamless.</p>
    </section>

    <section>
      <h2>Seamless & Secure Booking</h2>
      <p>We prioritize security and convenience, where you can either pay the hotel directly on arrival or departure (Pay at Property) or Pay Online in advance.  We support multiple payment options—including Apple Pay, Google Pay, and major credit cards—so you can book confidently, wherever you are.</p>
    </section>

    <section>
      <h3>Book Direct. Save More. Enjoy More.</h3>
    </section>
  </div>
</template>

<style scoped lang="scss" src="./documents.scss"></style>

<script setup lang="ts">

</script>
